export default __webpack_public_path__ + "static/media/star.8a91d9b3.svg";